import React, {useContext} from 'react';
import {Link} from '@reach/router';
import * as signUpConstants from 'constants/signUp';
import {I18N, I18NContext, I18NConsumer, GlobalContext} from 'commons';
import EbCard from 'commons/Card/Card';
import {orgId, baseUrl, setPageTitle, cookies} from 'utils';
import {selectShouldShowIncidentSub} from 'state/selectors/subscriptionSelectors';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import SignUpContent from '../SignUpContent';
import SignUpHeader from '../SignUpHeader';
import MyProfileSection from './MyProfileSection';
import LocationSection from './LocationSection';
import SubscriptionsSection from './SubscriptionsSection';
import AdditionalInformationSection from './AdditionalInformationSection';

const ReviewSection = ({shouldIncidentSubShow}) => {
    const {
        account: {id: contactId},
        organization: {
            orgName, showCustomfield, showAddress, showProfile,
            showAlertSubscription, showGroupSubscription,
        },
    } = useContext(GlobalContext);
    const i18n = useContext(I18NContext);
    const showSubscription = showAlertSubscription || showGroupSubscription || shouldIncidentSubShow;
      
    const entryFromPublicPortal = cookies.get("entryFromPublicPortal", {
        path: `/${orgId}`
    });
    const redirectToHome = () => {
        if (entryFromPublicPortal) {
            const url = `${baseUrl}/manage/${orgId}/${contactId}?entryFromPublicPortal=true#/portal-home`;
            console.log("Generated URL:", url);
            window.location.href = url;
        } else {
            window.location.href = `${baseUrl}/manage/${orgId}/${contactId}#/home`;
        }
    };

    return (
        <div className="sign-up review container ssp-well">
            <I18NConsumer>
                {() => setPageTitle(`${orgName} - ${i18n['ssp.information.review']}`)}
            </I18NConsumer>
            <h1 className="sr-only">{orgName} - {i18n['ssp.information.review']}</h1>
            <SignUpHeader currentSection={signUpConstants.SIGN_UP_SECTIONS.review.id}/>
            <I18N
                tag={SignUpContent}
                isInLoggedInEditProfileMode={false}
                i18n-title="ssp.information.review"
            >
                <h2 className="sr-only">{i18n['ssp.information.review']}</h2>
                <div className="row">
                    <div className="col-12">
                        <p className="content" id="content">
                            <I18N>ssp.register.review.tip</I18N>
                        </p>
                    </div>
                    <div className="col-12 col-lg-8">
                        {showProfile &&
                            <section className="form-group" aria-labelledby="profile-section-heading">
                                <h3 id="profile-section-heading">
                                    <Link
                                        to="../edit-profile"
                                        eb-test="ssp_review_button_edit_profile"
                                    >
                                        {i18n['ssp.register.review.section.tilte.myProfile']} ({i18n['ssp.address.grid.edit']})
                                    </Link>
                                </h3>
                                <EbCard showFooter={false}>
                                    <MyProfileSection/>
                                </EbCard>
                            </section>
                        }
                        {showAddress &&
                            <section className="form-group" aria-labelledby="location-section-heading">
                                <h3 id="location-section-heading">
                                    <Link
                                        to="../edit-mylocation"
                                        eb-test="ssp_review_button_edit_mylocation"
                                    >
                                        {i18n['ssp.register.review.section.tilte.location']} ({i18n['ssp.address.grid.edit']})
                                    </Link>
                                </h3>
                                <EbCard showFooter={false}>
                                    <LocationSection/>
                                </EbCard>
                            </section>
                        }
                        {showSubscription &&
                            <section className="form-group" aria-labelledby="subscriptions-section-heading">
                                <h3 id="subscriptions-section-heading">
                                    <Link
                                        to="../edit-subscriptions"
                                        eb-test="ssp_review_button_edit_subscriptions"
                                    >
                                        {i18n['ssp.register.review.section.tilte.subscriptions']} ({i18n['ssp.address.grid.edit']})
                                    </Link>
                                </h3>
                                <EbCard showFooter={false}>
                                    <SubscriptionsSection showIncidentSub={shouldIncidentSubShow}/>
                                </EbCard>
                            </section>
                        }
                        {showCustomfield &&
                            <section className="form-group" aria-labelledby="additional-info-section-heading">
                                <h3 id="additional-info-section-heading">
                                    <Link
                                        to="../edit-additionalInformation"
                                        eb-test="ssp_review_button_edit_additionalInformation"
                                    >
                                        {i18n['ssp.register.review.section.tilte.additionalInfo']} ({i18n['ssp.address.grid.edit']})
                                    </Link>
                                </h3>
                                <EbCard showFooter={false}>
                                    <AdditionalInformationSection/>
                                </EbCard>
                            </section>
                        }
                        <div className="d-block">
                            <div className="col-12 pr-0 text-right">
                                <button
                                    type="submit"
                                    className="btn btn-primary col-5"
                                    onClick={redirectToHome}
                                    eb-test="ssp_review_button_finish"
                                >
                                    <I18N>button.finish</I18N>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </I18N>
            <footer aria-label="Footer">
                <h2 className="sr-only">Footer</h2>
                {/* Footer content */}
            </footer>
        </div>
    );
};

ReviewSection.propTypes = {
    shouldIncidentSubShow: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    shouldIncidentSubShow: selectShouldShowIncidentSub(state),
});

export default connect(mapStateToProps)(ReviewSection);
